module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"end":"Ende","start":"Start","subject":"Modul","title":"Bezeichnung"},"en":{"end":"End","start":"Start","subject":"Subject","title":"Title"}}')
  delete Component.options._Ctor
}
